export default __webpack_public_path__ + "assets/images/listen-icon7-94e42b11.svg";